import { render } from "./SubmissionCard.vue?vue&type=template&id=c16fc3e0&scoped=true"
import script from "./SubmissionCard.vue?vue&type=script&lang=js"
export * from "./SubmissionCard.vue?vue&type=script&lang=js"

import "./SubmissionCard.vue?vue&type=style&index=0&id=c16fc3e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16fc3e0"]])

export default __exports__